import { tableStyles as ts } from "../../components/TableParts";
import { t } from "../../i18n";

export type AgentsPageTab = "list" | "reports";

const TABS: ReadonlyArray<AgentsPageTab> = ["list", "reports"];

export function AgentPageTabs({
  active,
  onChange,
}: {
  active: AgentsPageTab;
  onChange: (tab: AgentsPageTab) => void;
}): React.JSX.Element {
  return (
    <div style={styles.tabBar}>
      {TABS.map((tab) => (
        <button
          key={tab}
          type="button"
          aria-pressed={active === tab}
          onClick={() => onChange(tab)}
          style={{
            ...ts.filterBtn,
            ...(active === tab ? ts.filterBtnActive : undefined),
          }}
        >
          {t(`agents.tab_${tab}`)}
        </button>
      ))}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  tabBar: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 16,
  },
};
